import React from "react";

/** Preset quick-pick colors (9 fixed + current). */
export const QUICK_COLOR_PRESETS = [
  "#FFFFFF",
  "#000000",
  "#DB4831",
  "#C95E03",
  "#DBCF0D",
  "#2BAC40",
  "#57A1D0",
  "#0422FF",
  "#9909ED",
];

/**
 * Row of 10 quick-pick color swatches.
 * The 10th swatch is the currently selected color.
 *
 * @param {object}   props
 * @param {string}   props.currentColor - hex string of current color
 * @param {Function} props.onSelect     - (hex: string) => void
 */
const QuickColors = ({ currentColor, onSelect }) => {
  const swatches = [...QUICK_COLOR_PRESETS, currentColor];

  return (
    <div className="quick-colors">
      {swatches.map((color, idx) => (
        <button
          key={`${color}-${idx}`}
          type="button"
          className="quick-colors__swatch"
          style={{ backgroundColor: color }}
          title={color}
          aria-label={color}
          onClick={() => onSelect(color)}
        />
      ))}
    </div>
  );
};

export default QuickColors;
